export enum SearchCategory {
  Driver = 'Driver',
  Truck = 'Truck',
  Customer = 'Customer',
}
